import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../../graphql/types.generated';
export type BookingDocumentGenerationSubscriptionVariables = GraphQLTypes.Exact<{
  zencargoReference: GraphQLTypes.Scalars['String']['input'];
}>;

export type BookingDocumentGenerationSubscriptionResult = { __typename?: 'Subscription' } & {
  bookingDocumentGeneration: { __typename?: 'BookingDocument' } & Pick<GraphQLTypes.BookingDocument, 'error' | 'state'>;
};

export const BookingDocumentGenerationDocument = gql`
  subscription bookingDocumentGeneration($zencargoReference: String!) {
    bookingDocumentGeneration(zencargoReference: $zencargoReference) {
      error
      state
    }
  }
`;
